import React from 'react'
import './RequestOverTimeChart.css'

const RequestOverTimeChart = ({ data, title }) => {
  // Handle empty data
  const safeData = data && data.length > 0 ? data : []
  
  // Calculate chart dimensions
  const chartHeight = 200
  const chartWidth = 600
  const padding = { top: 20, right: 40, bottom: 40, left: 50 }
  const graphWidth = chartWidth - padding.left - padding.right
  const graphHeight = chartHeight - padding.top - padding.bottom
  const maxValue = safeData.length > 0 
    ? Math.max(...safeData.map(d => d.value || 0), 100) 
    : 100
  
  // Generate points for the line
  const points = safeData.length > 0
    ? safeData.map((point, index) => {
        const x = padding.left + (index / (safeData.length - 1 || 1)) * graphWidth
        const y = padding.top + graphHeight - ((point.value || 0) / maxValue) * graphHeight
        return { x, y, value: point.value || 0 }
      })
    : []

  const pathData = points.length > 0
    ? points.map((point, index) => {
        return index === 0 ? `M ${point.x} ${point.y}` : `L ${point.x} ${point.y}`
      }).join(' ')
    : ''

  return (
    <div className="chart-card">
      <h2 className="chart-title">{title || 'Request Over Time'}</h2>
      <div className="chart-container">
        <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} className="chart-svg" preserveAspectRatio="xMidYMid meet">
          {/* Y-axis grid lines and labels */}
          {[0, 20, 40, 60, 80, 100].map((val) => {
            const y = padding.top + graphHeight - (val / maxValue) * graphHeight
            return (
              <g key={val}>
                <line
                  x1={padding.left}
                  y1={y}
                  x2={chartWidth - padding.right}
                  y2={y}
                  stroke="#f1f5f9"
                  strokeWidth="1"
                />
                <text
                  x={padding.left - 10}
                  y={y + 4}
                  fontSize="12"
                  fill="#64748b"
                  textAnchor="end"
                >
                  {val}
                </text>
              </g>
            )
          })}
          
          {/* Line chart */}
          {pathData && (
            <path
              d={pathData}
              fill="none"
              stroke="#2563eb"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          )}
          
          {/* Data points */}
          {points.map((point, index) => (
            <circle
              key={index}
              cx={point.x}
              cy={point.y}
              r="4"
              fill="#2563eb"
              stroke="#ffffff"
              strokeWidth="2"
            />
          ))}
        </svg>
        
        {/* X-axis labels */}
        <div className="chart-x-axis">
          {safeData.length > 0 ? (
            safeData.map((point, index) => (
              <span key={index} className="x-axis-label">
                {point.date}
              </span>
            ))
          ) : (
            <span className="x-axis-label" style={{ textAlign: 'center', width: '100%' }}>
              No data available
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default RequestOverTimeChart

